// Global packages and functions
import { useState, useEffect } from 'react'

// Get the window data
const getWindowDimensions = () => {
  const hasWindow = typeof window !== 'undefined'
  const width = hasWindow ? window.innerWidth : null
  const height = hasWindow ? window.innerHeight : null

  return {
    width,
    height,
  }
}

// Main export
const useWindowDimensions = () => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  )

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions())
    }

    window.addEventListener('resize', handleResize)

    return () => window.removeEventListener('resize', handleResize)
  }, [])

  return windowDimensions
}

export default useWindowDimensions
